import { render, staticRenderFns } from "./CommentsDrawer.vue?vue&type=template&id=0e9510c1"
import script from "./CommentsDrawer.vue?vue&type=script&lang=js"
export * from "./CommentsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports